<script>
  import { onMount } from 'svelte';

  let {message, onClose} = $props();
  onMount(() => {
    setTimeout(() => {
      onClose();
    }, 3000);
  });
</script>

<div id="message-wrap" style="color: { message.color };">
  { message.text }
</div>
